import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Circle, ClipPath, Defs, G, Path, Rect } from "react-native-svg";
import normalize from "app/utils/normalize";
import Animated, { useAnimatedProps } from "react-native-reanimated";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";

const AnimatedPath = isWeb ? Path : Animated.createAnimatedComponent(Path);

const CloseRoundIcon = ({
  height = normalize(32),
  width = normalize(32),
  color,
  ...props
}) => {
  const animatedProps = useAnimatedProps(() => {
    return {
      fill: color.value ? color.value : color,
    };
  });

  return (
    <Svg
      width={width}
      height={height}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 32 32"
      {...props}
    >
      <AnimatedPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9998 28.0001C22.6273 28.0001 27.9998 22.6275 27.9998 16.0001C27.9998 9.37264 22.6273 4.00006 15.9998 4.00006C9.37243 4.00006 3.99985 9.37264 3.99985 16.0001C3.99985 22.6275 9.37243 28.0001 15.9998 28.0001ZM15.9962 14.4968L20.4948 9.99815C20.6937 9.7993 20.9634 9.68758 21.2446 9.68758C21.5258 9.68758 21.7955 9.7993 21.9944 9.99815C22.1932 10.197 22.3049 10.4667 22.3049 10.7479C22.3049 11.0291 22.1932 11.2988 21.9944 11.4977L17.4957 15.9963L21.9944 20.4949C22.1932 20.6938 22.3049 20.9635 22.3049 21.2447C22.3049 21.5259 22.1932 21.7956 21.9944 21.9945C21.7955 22.1933 21.5258 22.3051 21.2446 22.3051C20.9634 22.3051 20.6937 22.1933 20.4948 21.9945L15.9962 17.4959L11.4976 21.9945C11.2987 22.1933 11.029 22.3051 10.7478 22.3051C10.4666 22.3051 10.1969 22.1933 9.99802 21.9945C9.79916 21.7956 9.68745 21.5259 9.68745 21.2447C9.68745 20.9635 9.79916 20.6938 9.99802 20.4949L14.4966 15.9963L9.99802 11.4977C9.79916 11.2988 9.68745 11.0291 9.68745 10.7479C9.68745 10.4667 9.79916 10.197 9.99802 9.99815C10.1969 9.7993 10.4666 9.68758 10.7478 9.68758C11.029 9.68758 11.2987 9.7993 11.4976 9.99815L15.9962 14.4968Z"
        animatedProps={animatedProps}
      />
    </Svg>
  );
};

export default CloseRoundIcon;
